var map = {
	"./map-CB.png": 2334,
	"./map-CN.png": 4853,
	"./map-DG.png": 9930,
	"./map-GB.png": 9090,
	"./map-GG.png": 9567,
	"./map-GJ.png": 1370,
	"./map-GN.png": 4238,
	"./map-GW.png": 559,
	"./map-IC.png": 2773,
	"./map-JB.png": 9117,
	"./map-JJ.png": 5765,
	"./map-JN.png": 9425,
	"./map-US.png": 977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8690;